import { Tag } from "antd";

import { ICaseEquipment } from "store/cases/cases.types";

interface IProps {
  caseEquipment: ICaseEquipment;
}

const CaseEquipmentInfo = ({ caseEquipment }: IProps) => {
  return (
    <div className="case-equipment-wrapper">
      <p className="case-equipment-description">
        { caseEquipment.product.description }
      </p>

      <p className="case-equipment-client">
        { caseEquipment.customer?.latin_name }
      </p>

      <div className="case-equipment-dates-wrapper">
        <p className="case-equipment-dates">
          { caseEquipment.date_begin } - { caseEquipment.date_end }
        </p>

        <Tag
          className={ `${ caseEquipment.is_pending ? "pending" : caseEquipment.support_type }` }
          style={ {
            background: caseEquipment.sla_ci.marker_bg_color,
            color: caseEquipment.sla_ci.marker_text_color,
          } }
        >
          { caseEquipment?.sla_ci.marker }
        </Tag>
      </div>
    </div>
  );
};

export default CaseEquipmentInfo;
